import { GLDetailsHeader, GLDetailsHeaderRating, GLDetailsHeaderTitle, GlobalViewDetailsContainer, SelectedPinAction } from './GlobalView.styled'
import Avatar from '../../assets/images/profileAvatar.png'
import { OtherText, TitleText } from 'styling/Typography'
import { RatingIcon } from 'assets/icons/RatingIcon'
import { ISelectedPin } from 'types/global-view.interface'
import { XIcon } from 'assets/icons/XIcon'
import { ShrinkIcon } from 'assets/icons/ShrinkIcon'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { handleMachineStatus } from 'utils/helpers'
import { SetStateAction, useRef } from 'react'
import { WorkerDetails } from './Details/DetailsWorker'
import { MachineDetails } from './Details/MachineDetails'
import { MachineTrips } from './Details/MachineTrips'

export const GlobalViewDetails = ({ map, openedPin, handleClosePin, handleUnselectPin, setSelectedPins }: { setSelectedPins: React.Dispatch<SetStateAction<ISelectedPin[]>>, map: any, openedPin: ISelectedPin, handleClosePin: (pin: ISelectedPin) => void, handleUnselectPin: (pin: ISelectedPin, unselect?: boolean) => void }) => {
    const { workerInfo, machineInfo } = useSelector((state: RootState) => state.globalView)
    const historyRef = useRef(null)

    const unselectPin = (openedPin: ISelectedPin) => {
        if (historyRef.current) {
            historyRef.current.setMap(null)
            historyRef.current = null
        }
        handleUnselectPin(openedPin, true)
    }

    const handleCloseTrips = () => {
        setSelectedPins(prev => prev.map(p => ({ ...p, showTrips: false })))
    }
    return <GlobalViewDetailsContainer closed={!openedPin?.id} >
        <SelectedPinAction style={{ top: '1.3rem' }} onClick={() => unselectPin(openedPin)} ><XIcon /></SelectedPinAction>
        <SelectedPinAction style={{ top: '3.5rem' }} onClick={() => handleClosePin(openedPin)}> <ShrinkIcon /> </SelectedPinAction>
        <GLDetailsHeader>
            <GLDetailsHeaderTitle>
                <img src={(openedPin?.type == 'employee' ? workerInfo?.profileImageUrl : machineInfo?.category?.imageUrl) || Avatar} />
                <div className="text">
                    <TitleText color='white' weight="600" >{openedPin?.name}</TitleText>
                    <OtherText color='white' >{openedPin?.type == 'employee' ? workerInfo?.role.name : (machineInfo?.user ? (machineInfo?.user?.firstName + ' ' + machineInfo?.user?.lastName) : '/')}</OtherText>
                    {openedPin?.type == 'machine' && <OtherText color='white' >Status: <span style={{ fontWeight: 'bold' }} >{handleMachineStatus(machineInfo?.status)}</span></OtherText>}
                </div>
            </GLDetailsHeaderTitle>
            <GLDetailsHeaderRating>
                <RatingIcon />
                <OtherText color='white' >{workerInfo?.rating?.qualityRating}</OtherText>
            </GLDetailsHeaderRating>
        </GLDetailsHeader>
        {openedPin?.showTrips ? <MachineTrips closeTrips={handleCloseTrips} map={map} /> : openedPin?.type == 'employee' ? <WorkerDetails /> : <MachineDetails openedPin={openedPin} map={map} setSelectedPins={setSelectedPins} />}

    </GlobalViewDetailsContainer>
}